import { BoxProps } from '@chakra-ui/react';
export const overlayStyle: BoxProps = {
  h: 'full',
  w: 'full',
  bg: 'rgba(0,0,0,0.6)',
  pos: 'absolute',
  top: '0',
  left: '0',
  right: '0',
  bottom: '0',
};

export const sliderItemStyle: BoxProps = {
  w: 'full',
  pos: 'relative',
  minH: '100vh',
  px: '10',
  py: '80px',
  bgSize: 'cover',
  bgPos: 'center',
  display: 'flex',
  alignItems: 'flex-end',
  color: 'white',
};
